import { RouterModule, Routes } from '@angular/router';
import { NotAuthGuardService } from '@services';
import { StatusFailedGuardService } from '../shared/services/status-failed-guard.service';
import { AccessForbiddenComponent } from './access-forbidden/access-forbidden.component';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { StatusComponent } from './status/status.component';

export const homeRoutes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [NotAuthGuardService, StatusFailedGuardService],
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: 'access-forbidden',
    component: AccessForbiddenComponent,
  },
  {
    path: 'status',
    component: StatusComponent,
  },
];

export const HomeRouting = RouterModule.forChild(homeRoutes);
